import { render, staticRenderFns } from "./Unqualified.vue?vue&type=template&id=6d82f070&scoped=true&"
import script from "./Unqualified.vue?vue&type=script&lang=js&"
export * from "./Unqualified.vue?vue&type=script&lang=js&"
import style0 from "./Unqualified.vue?vue&type=style&index=0&id=6d82f070&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82f070",
  null
  
)

export default component.exports